import PropTypes from "prop-types";
import SideBarContainer from "../../containers/SideBarContainer";

DashboardContext.propTypes = {
  page: PropTypes.string,
  children: PropTypes.node,
};

export default function DashboardContext({ page, children }) {
  return (
    <div className="layout-main">
      <SideBarContainer />
      <div className="layout-content">
        <div className="layout-content-body">
          <div className="title-bar" style={{ display: "block" }}>
            <p className="title-bar-description">
              <small>{page}</small>
            </p>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
